module.exports = __webpack_public_path__ + "static/media/book.fa3b38c7.svg";